<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <!-- <div class="search">
            <input type="text" v-model="query.productName" @change="queryChange" />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span> -->
        </div>
      </div>
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="操作" min-width="260">
              <template slot-scope="scope">
                <el-button type="text" size="small" v-preventReClick class="color-blue" @click="viewClick(scope.row)">查看履历</el-button>
                <!-- <el-button type="text" size="small" @click="print(scope.row)" v-preventReClick class="color-blue"> RFID打印 </el-button> -->
                <!-- @click="print(scope.row)" -->
                <el-button type="text" size="small" v-if="scope.row.state != 0" @click="print1(scope.row)" class="margin-left20 color-blue">普通打印</el-button>
                <!-- @click="handleDelete(scope.row)" -->
                <el-button v-if="scope.row.enableState == 1" size="small" type="text" v-preventReClick
                  class="margin-left20 color-blue" @click="cancelCoed(scope.row)" >作废</el-button>
    
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
          <el-table-column prop="deptName" width="120" label="科室" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" width="150" label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productRegistCertName" width="150" label="注册证名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specName" width="150" label="规格型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="manufacturerName" width="150" label="生产厂家" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bookStock" width="100" label="账面库存"></el-table-column>
          <el-table-column prop="stockQuantity" width="100" label="库存数量"></el-table-column>
          <el-table-column prop="minUnit" width="100" label="最小单位"></el-table-column>
          <el-table-column prop="price" width="80" label="价格"></el-table-column>
          <el-table-column prop="amount" width="100" label="小计"></el-table-column>
          <el-table-column prop="batch" width="130" label="批号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="stockCategoryName" width="90" label="库存类型" show-overflow-tooltip></el-table-column>
          <el-table-column prop="manufactureDate" width="120" label="生产日期">
            <template slot-scope="scope">
              {{scope.row.manufactureDate?parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}"):'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="validityDate" width="120" label="有效期">
            <template slot-scope="scope">{{ scope.row.validityDate?parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}"):'-' }}</template>
          </el-table-column>
          <el-table-column prop="longTime" label="长期" width="60">
            <template slot-scope="scope">
              {{ scope.row.longTime == 1 ? "是" : "否"}}
            </template>
          </el-table-column>
  
          <el-table-column prop="mainNo" width="150" label="主条码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.mainNo?scope.row.mainNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="traceNo" label="溯源码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.traceNo?scope.row.traceNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="onlineNo" label="挂网号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.onlineNo?scope.row.onlineNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="supplierName" width="120" label="供应商" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productTypeName" width="90" label="产品类型" show-overflow-tooltip></el-table-column>
          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
          <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row.stockIds)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
   

    </div>
    <div class="pagination">
      <span style="float: left">金额合计(元)：{{ totalAmount }}元</span>
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
     <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetThreeStocks,
  GetTagCodeList
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    LabelDetailsDialog,
    PackageLabelDialog,
  },
  data () {
    return {
      GetDatasAction: GetThreeStocks,
      // RemoveAction: RemoveThreeStockReset,
      // PrintAction: SpdGetStockProfitLossPrintData,
      // editPath: 'three-stock-reset-edit',

      StockCategoryOptions: StockCategoryOptions,
      filterOptions: [
        {
          name: "科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "库存类别",
          type: "select",
          code: "stockCategory",
          data: StockCategoryOptions,
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo"
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName"
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName"
        },
        {
          name: "计费价",
          type: "input",
          code: "price",
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        // {
        //   name: "主条码",
        //   type: "input",
        //   code: "mainNo",
        // },
      ],
      labelDetailsData: {},// 标签详情数据
      packageLabeData: {},// 包装标签数据
      labelDetailsVisible: false,// 标签详情弹窗
      packageLabelVisible: false,// 包装标签弹窗
      labelDetaiPaternity: {},
      labelPackVisible: false,// 标签打印弹窗
    };
  },
  methods: {
    tagCodeView (id) {

      GetTagCodeList({
        stockIds: id,
        pageSize:999
      }).then((res) => {
        this.labelDetailsVisible = true;
        this.labelDetailsData = res.returnData;
      });

    },
    closeLabelDetailsDialog () {
      this.labelDetailsVisible = false
      this.labelDetailsData = {}
    },
    closePackageLabelDialog () {
      this.packageLabelVisible = false
      this.packageLabeData = {}
      this.labelDetailsData = {}
    },
    tagCodeDelete (row) {
      this.form.details.filter(res => res == this.labelDetaiPaternity)[0].tagCodeViewModels = row
      this.form.details.filter(res => res == this.labelDetaiPaternity)[0].number--
      this.form.details.filter(res => res == this.labelDetaiPaternity)[0].amount = this.form.details.filter(res => res == this.labelDetaiPaternity)[0].number * this.form.details.filter(res => res == this.labelDetaiPaternity)[0].price
    }
  },
  mounted () {
  },
};
</script>

<style lang="scss" scoped></style>
